// extracted by mini-css-extract-plugin
export default {"socialLinks":"Footer_socialLinks__mFs7W","socialList":"Footer_socialList__-AM4q","socialListItem":"Footer_socialListItem__hAkUA","copyright":"Footer_copyright__2WB24"};